const colorScheme = {
  name: "color-scheme",
  path: "/color-scheme",
  title: "color-scheme",
  description: "Utilities for controlling the CSS color-scheme property.",
  value: {
    "color-scheme": {
      "scheme-light": "light",
      "scheme-dark": "dark",
      "scheme-normal": "normal",
      "scheme-light-dark": "light dark",
      "scheme-only-dark": "only dark",
      "scheme-only-light": "only light"
    }
  },
  exampleData: [
    {
      example: {
        code: `<div class="scheme-light ...">
  <input type="date" />
</div>
<div class="scheme-dark ...">
  <input type="date" />
</div>
<div class="scheme-light-dark ...">
  <input type="date" />
</div>`
      }
    }
  ],
  htmlData: [
    {
      title: "Color scheme",
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">scheme-light</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">scheme-dark</code>, or other <code>color-scheme</code> utilities to set the preferred color scheme for an element.
      </p>
        <div class="flex justify-between gap-8 text-sm max-sm:flex-col">
        <div class="flex grow flex-col items-center gap-3 text-center scheme-light">
            <p class="font-mono font-medium text-gray-500 dark:text-gray-400">scheme-light</p>
            <input class="w-full rounded-lg border border-color-gray-950/10 px-3 py-2 dark:border-color-white/10" type="date">
        </div>
        <div class="flex grow flex-col items-center gap-3 text-center scheme-dark">
            <p class="font-mono font-medium text-gray-500 dark:text-gray-400">scheme-dark</p>
            <input class="w-full rounded-lg border border-color-gray-950/10 px-3 py-2 dark:border-color-white/10" type="date">
        </div>
        <div class="flex grow flex-col items-center gap-3 text-center scheme-light-dark">
            <p class="font-mono font-medium text-gray-500 dark:text-gray-400">scheme-light-dark</p>
            <input class="w-full rounded-lg border border-color-gray-950/10 px-3 py-2 dark:border-color-white/10" type="date">
        </div>
        </div>
      `
    }
  ]
};

export default colorScheme;
<div class="flex justify-between gap-8 text-sm max-sm:flex-col">
   <div class="flex grow flex-col items-center gap-3 text-center scheme-light">
      <p class="font-mono font-medium text-gray-500 dark:text-gray-400">scheme-light</p>
      <input class="w-full rounded-lg border border-color-gray-950/10 px-3 py-2 dark:border-color-white/10" type="date"/>
   </div>
   <div class="flex grow flex-col items-center gap-3 text-center scheme-dark">
      <p class="font-mono font-medium text-gray-500 dark:text-gray-400">scheme-dark</p>
      <input class="w-full rounded-lg border border-color-gray-950/10 px-3 py-2 dark:border-color-white/10" type="date"/>
   </div>
   <div class="flex grow flex-col items-center gap-3 text-center scheme-light-dark">
      <p class="font-medium text-gray-500 dark:text-gray-400">scheme-light-dark</p>
      <input class="w-full rounded-lg border border-color-gray-950/10 px-3 py-2 dark:border-color-white/10" type="date"/>
   </div>
</div>